import Vue               from 'vue'
import 'babel-polyfill'
import * as Fingerprint2 from 'fingerprintjs2'
import VueMaterial       from 'vue-material'
import {Datetime}        from 'vue-datetime'
import Datepicker        from 'vuejs-datepicker'
import moment            from 'moment-timezone'
import MarkerClusterer   from 'js-marker-clusterer';
import _                 from 'lodash';
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import 'material-icons/iconfont/material-icons.scss'
import 'vue-datetime/dist/vue-datetime.css'
import '@/assets/scss/vue-datetime.scss'
import {Settings}        from 'luxon';
import App               from './App.vue'
import router            from './router'
import store             from './store'
import Validation        from './modules/validation'
import VueLazyload       from 'vue-lazyload'
import VueGtm from '@gtm-support/vue2-gtm';
moment.tz.setDefault('Asia/Tokyo');

Settings.defaultLocale   = 'ja';
Settings.defaultZoneName = 'Asia/Tokyo';

Vue.config.productionTip = false;
Vue.use(VueMaterial);
Vue.use(Validation);
Vue.use(VueLazyload);
Vue.use(VueGtm, {
  id: 'GTM-WQ3ZTGT',
  vueRouter: router,
});

// change single option
Vue.material.locale = {
  days         : ['日', '月', '火', '水', '木', '金', '土'],
  shortDays    : ['日', '月', '火', '水', '木', '金', '土'],
  shorterDays  : ['日', '月', '火', '水', '木', '金', '土'],
  months       : ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
  shortMonths  : ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  shorterMonths: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
};

Vue.component('datetime', Datetime);
Vue.component('datepicker', Datepicker);
Vue.prototype.$fingerprint = Fingerprint2;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
